<section [hidden]="isViewingCreelMap" class="initial-preparations-wrapper full-height flex-row">
  <div class="full-width initial-preparations-wrapper-child">
    <div class="full-height flex-column">
      <mat-card class="skeleton-wrapper full-max-height" [class.skeleton]="isLoadingProductionSchedule" [@fadeIn]="isLoadingProductionSchedule">
        <mat-card-header class="flex-start-center">
          <mat-card-title class="antialiased flex-row flex-start-center">
            <h3 class="font-weight-bold">{{ 'GENERAL.ACTIONS.CREATE_OBJECT' | bmsTranslate: {object: 'PRODUCTION_ORDER.PRODUCTION_ORDER' | bmsTranslate: {count: 1} | lowercase} }}</h3>
          </mat-card-title>
          <div class="flex-1 flex-end-center header-actions">
            <button mat-icon-button class="mat-icon-action-button-lg-with-border" (click)="navigateToCustomSettings()" [matTooltip]="'GENERAL.CUSTOM_SETTINGS.CUSTOM_SETTINGS' | bmsTranslate">
              <mat-icon svgIcon="settings"></mat-icon>
            </button>
          </div>
        </mat-card-header>
        <mat-card-content class="form-scrollable-content">
          <article [formGroup]="productionScheduleInitialPreparationsForm">
            <div class="flex-row gap-16 disabled-container">
              <div class="form-field-skeleton-wrapper form-field">
                <mat-form-field *ngIf="!productionSchedule.isBeingDecreated() || !areAllFieldsDisabled; else disabledNameFormInput" class="full-width">
                  <mat-label>{{ 'GENERAL.NAME' | bmsTranslate }}</mat-label>
                  <input matInput type="text" formControlName="name" />

                  @if (!areAllFieldsDisabled) {
                    <mat-hint class="flex-1">
                      <app-name-suggestion-hint
                        [currentName]="productionScheduleInitialPreparationsForm?.controls.name.value"
                        [nameGenerationEntity]="productionScheduleNameGenerationView"
                        [httpRepository]="httpProductionOrdersCustomSettings"
                        [externalRefresh]="refreshNameGeneration"
                        (applySuggestion)="applySuggestionForProductionScheduleName($event)"
                      />
                    </mat-hint>
                  }

                  <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'required'">
                    {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                  </mat-error>

                  <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'">
                    {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }}
                  </mat-error>

                  <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'maxlength'">
                    {{ 'GENERAL.ERRORS.LENGTH_LIMIT' | bmsTranslate: {max: '24'} }}
                  </mat-error>

                  <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'pattern'">
                    {{ 'GENERAL.ERRORS.NO_SPECIAL_CHARACTERS' | bmsTranslate }}
                  </mat-error>
                </mat-form-field>

                <ng-template #disabledNameFormInput>
                  <app-disabled-form-input class="full-width" [label]="'GENERAL.NAME' | bmsTranslate" [value]="productionScheduleInitialPreparationsForm.get('name').value"> </app-disabled-form-input>
                </ng-template>
              </div>

              <div class="form-field-skeleton-wrapper form-field disabled-container">
                <ng-container *ngIf="!canShowDisabledFormInputs() || !areAllFieldsDisabled; else disabledMachineFormInput">
                  <mat-form-field class="full-width">
                    <mat-label>{{ 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | bmsTranslate }}</mat-label>
                    <vdw-object-selection
                      formControlName="machine"
                      [objectName]="'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase"
                      [baseRouterLink]="MACHINE_BASE_ROUTER_LINK"
                      (selectClicked)="selectMachine()"
                    ></vdw-object-selection>
                    <mat-error *vdwCanShowErrorForFormControl="'machine'; error: 'required'">
                      {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                    </mat-error>
                  </mat-form-field>
                </ng-container>
              </div>
              <ng-template #disabledMachineFormInput>
                <app-disabled-form-input class="full-width" [label]="'MACHINE.MACHINE' | bmsTranslate: {count: 1}" [value]="selectedMachineName"></app-disabled-form-input>
              </ng-template>
            </div>

            <ng-container *ngIf="!canShowWarningForNoPossibleMatchesWithCurrentMachine()">
              <div class="skeleton-wrapper flex-row-wrap" [class.skeleton]="isLoadingMachineQualityAndCreel" [@fadeIn]="isLoadingMachineQualityAndCreel">
                <ng-container>
                  <div class="flex-row gap-16 full-width">
                    <div class="form-field-skeleton-wrapper disabled-forms-flex">
                      <div class="input-row" *ngIf="!hasChosenMachine()">
                        <span class="sub-title">
                          {{ 'TEXTILE_DATA.MACHINE_QUALITY.PRACTICALPICKDENSITY' | bmsTranslate }}
                        </span>
                        <span *ngIf="canShowLabelForMachineQualityAndCreel()">
                          {{ 'GENERAL.ERRORS.NO_OBJECT_CHOSEN' | bmsTranslate: {object: 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase} }}
                        </span>
                      </div>
                      <mat-form-field *ngIf="hasChosenMachine()" class="full-width">
                        <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.PRACTICALPICKDENSITY' | bmsTranslate }}</mat-label>
                        <input matInput type="number" formControlName="practicalPickDensity" />
                        <span matSuffix *ngIf="hasListOfMachineQualityCustomSettings()">
                          {{ 'GENERAL.UNIT.' + getDefaultParameterForPropertyNameOfMachineQualitySettings('pickDensityUnit').propertyValue | bmsTranslate }}
                        </span>
                        <mat-error *vdwCanShowErrorForFormControl="'practicalPickDensity'; error: 'min'">
                          {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: '1'} }}
                        </mat-error>
                        <mat-error *vdwCanShowErrorForFormControl="'practicalPickDensity'; error: 'required'">
                          {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="skeleton-wrapper form-field disabled-container" [class.skeleton]="isLoadingMachineQualityAndCreel" [@fadeIn]="isLoadingMachineQualityAndCreel">
                      <div class="form-field-skeleton-wrapper full-width" *ngIf="!canShowDisabledFormInputs(); else disabledMachineQualityFormInputs">
                        <div class="input-row" *ngIf="!hasChosenMachine()">
                          <span class="sub-title">
                            {{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} }}
                          </span>
                          <span *ngIf="canShowLabelForMachineQualityAndCreel()">
                            {{ 'GENERAL.ERRORS.NO_OBJECT_CHOSEN' | bmsTranslate: {object: 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase} }}
                          </span>
                        </div>

                        <mat-form-field *ngIf="hasChosenMachine()" class="full-width">
                          <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} | bmsTranslate }}</mat-label>
                          <vdw-object-selection
                            formControlName="machineQuality"
                            [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} | lowercase"
                            [chipValueKey]="QUALITY_CHIP_VALUE_KEY"
                            [baseRouterLink]="QUALITY_BASE_ROUTER_LINK"
                            (selectClicked)="selectAnotherMachineQuality()"
                          ></vdw-object-selection>
                          <mat-error *vdwCanShowErrorForFormControl="'machineQuality'; error: 'required'">
                            {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <ng-template #disabledMachineQualityFormInputs>
                        <div class="form-field-skeleton-wrapper disabled-container full-width">
                          <app-disabled-form-input
                            class="disabled-form-input disabled-forms-flex"
                            [label]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1}"
                            [value]="productionSchedule.machineQuality?.technicalNameWithVersion"
                          >
                          </app-disabled-form-input>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </ng-container>

                <ng-container>
                  <div class="flex-row gap-16 full-width">
                    @if (canSelectProductConfiguration()) {
                      <div
                        class="skeleton-wrapper form-field disabled-container"
                        *ngIf="!isAddingProductionOrderForRun()"
                        [class.skeleton]="isLoadingMachineQualityAndCreel"
                        [@fadeIn]="isLoadingMachineQualityAndCreel"
                      >
                        <div class="form-field-skeleton-wrapper full-width" *ngIf="!canShowDisabledFormInputs(); else disabledProductConfigurationFormInputs">
                          <div class="input-row" *ngIf="!hasChosenMachine()">
                            <span class="sub-title">
                              {{ 'PRODUCT_CONFIGURATION.PRODUCT_CONFIGURATION' | bmsTranslate: {count: 1} }}
                            </span>
                            <span *ngIf="canShowLabelForMachineQualityAndCreel()">
                              {{ 'GENERAL.ERRORS.NO_OBJECT_CHOSEN' | bmsTranslate: {object: 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase} }}
                            </span>
                          </div>

                          <mat-form-field *ngIf="hasChosenMachine()" class="full-width">
                            <mat-label>
                              {{ 'PRODUCT_CONFIGURATION.PRODUCT_CONFIGURATION' | bmsTranslate: {count: 1} | bmsTranslate
                              }}<span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
                            </mat-label>
                            <vdw-object-selection
                              formControlName="productConfiguration"
                              [objectName]="'PRODUCT_CONFIGURATION.PRODUCT_CONFIGURATION' | bmsTranslate: {count: 1} | lowercase"
                              [chipValueKey]="PRODUCT_CONFIGURATION_CHIP_VALUE_KEY"
                              [baseRouterLink]="PRODUCT_CONFIGURATION_BASE_ROUTER_LINK"
                              (selectClicked)="selectProductConfiguration()"
                              (clearClicked)="removeProductConfiguration()"
                            ></vdw-object-selection>
                          </mat-form-field>
                        </div>

                        <ng-template #disabledProductConfigurationFormInputs>
                          <div class="form-field-skeleton-wrapper disabled-container full-width">
                            <app-disabled-form-input
                              *ngIf="canShowProductConfigurationDisabledFormInput()"
                              class="disabled-form-input disabled-forms-flex"
                              [label]="'PRODUCT_CONFIGURATION.PRODUCT_CONFIGURATION' | bmsTranslate: {count: 1}"
                              [value]="productionScheduleInitialPreparationsForm.get('productConfiguration').value?.nameWithVersion"
                            >
                            </app-disabled-form-input>
                          </div>
                        </ng-template>
                      </div>
                    }
                    @if (canSelectBuggy()) {
                      <div class="skeleton-wrapper form-field" [class.skeleton]="isLoadingMachineQualityAndCreel" [@fadeIn]="isLoadingMachineQualityAndCreel">
                        <div class="form-field-skeleton-wrapper full-width">
                          <div class="input-row" *ngIf="!hasChosenMachine()">
                            <span class="sub-title">
                              {{ 'PLANNING.BUGGY.BUGGY' | bmsTranslate: {count: 1} }}
                            </span>
                            <span *ngIf="canShowLabelForMachineQualityAndCreel()">
                              {{ 'GENERAL.ERRORS.NO_OBJECT_CHOSEN' | bmsTranslate: {object: 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase} }}
                            </span>
                          </div>

                          <mat-form-field *ngIf="hasChosenMachine()" class="full-width">
                            <mat-label>
                              {{ 'PLANNING.BUGGY.BUGGY' | bmsTranslate: {count: 1} | bmsTranslate }}<span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
                            </mat-label>
                            <vdw-object-selection
                              formControlName="buggy"
                              [objectName]="'PLANNING.BUGGY.BUGGY' | bmsTranslate: {count: 1} | lowercase"
                              [baseRouterLink]="BUGGY_BASE_ROUTER_LINK"
                              (selectClicked)="selectBuggy()"
                              (clearClicked)="removeBuggy()"
                            ></vdw-object-selection>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                  </div>
                </ng-container>
              </div>

              <div class="skeleton-wrapper input-row flex-row" [class.skeleton]="isLoadingMachineQualityAndCreel" [@fadeIn]="isLoadingMachineQualityAndCreel">
                <div class="flex-1 flex-column gap-16">
                  <div class="flex-row">
                    <div class="flex-column flex-100" *ngIf="hasChosenMachine()">
                      <div class="input-row flex-start-start" *ngIf="!canShowDetailsOfActiveCreel()">
                        <button mat-stroked-button type="button" [disabled]="areAllFieldsDisabled" (click)="selectAnotherCreel()" [class.mat-warn]="needsToShowValidationFeedback">
                          {{ 'GENERAL.ACTIONS.SELECT_OBJECT' | bmsTranslate: {object: 'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1} | lowercase} }}
                        </button>
                      </div>
                      <article *ngIf="canShowDetailsOfActiveCreel()" class="colored-yarn-sets-container">
                        <header class="flex-row">
                          <p class="flex-start-center url" [class.disabled]="isProductionScheduleRelatedToRunOrBeingDecreated() || areAllFieldsDisabled" (click)="selectAnotherCreel()">
                            {{ 'TEXTILE_DATA.COLORED_YARN_SET.COLORED_YARN_SET' | bmsTranslate: {count: 2} }}
                          </p>
                          <div class="flex-1 flex-end-center gap-16">
                            <mat-icon *ngIf="canShowWarningForIncorrectSplittedCreel" [matTooltip]="'TEXTILE_DATA.CREEL.WARNING_SPLITTED_CREEL' | bmsTranslate" svgIcon="warning"></mat-icon>
                          </div>
                        </header>
                        <div class="colored-yarn-sets-content flex-column gap-16">
                          <ng-container *ngFor="let productionScheduleColoredYarnSet of productionSchedule.coloredYarnSets; let coloredYarnSetIndex = index">
                            <div *ngIf="canShowColoredYarnSet(coloredYarnSetIndex)" class="flex-column colored-yarn-set form-field-skeleton-wrapper gap-8">
                              <span class="sub-title">
                                {{ productionScheduleColoredYarnSet.coloredYarnSet?.name }}
                              </span>
                              <div class="input-link flex-row flex-start-center">
                                <app-color-list-preview
                                  [colorList]="getColorList(productionScheduleColoredYarnSet.coloredYarnSet)"
                                  [showDetailsOnClick]="false"
                                  (click)="showColoredYarnSetDetails($event, productionScheduleColoredYarnSet)"
                                  [creelMapping]="getCreelMapping(productionScheduleColoredYarnSet.coloredYarnSet)"
                                >
                                </app-color-list-preview>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </article>
                    </div>
                  </div>
                  <div class="flex-row" *ngIf="canShowDetailsOfActiveCreel()">
                    <button mat-flat-button type="button" color="primary" [disabled]="productionSchedule.isRelatedToRun() || areAllFieldsDisabled" (click)="openCreelMap()">
                      {{ 'MACHINE.DETAILS.EDIT_MAPPING' | bmsTranslate }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            <div [hidden]="!canShowWarningForNoPossibleMatchesWithCurrentMachine()" class="warning-for-no-possible-matches-with-current-machine flex-row flex-start-center gap-16">
              <mat-icon svgIcon="warning"></mat-icon>
              <span>{{ 'PRODUCTION_ORDER.WARNINGS.NO_POSSIBLE_MATCHES_WITH_CURRENT_MACHINE' | bmsTranslate }}</span>
            </div>

            <app-production-schedule-initial-preparations-additional-options
              #initialPreparationsAdditionalOptionsComponent
              *ngIf="canShowAdditionalOptions"
              [customSettings]="customSettings"
              [machine]="selectedMachine"
              [machineQuality]="productionSchedule?.machineQuality"
              [creel]="productionSchedule?.creel"
              [coloredYarnSets]="productionSchedule?.coloredYarnSets"
              [freeZone]="productionSchedule?.initialFreeZones"
              [restZone]="productionSchedule?.initialRestZones"
              [finishing]="productionSchedule?.finishing"
              [dueDate]="productionSchedule?.dueDate"
              [comment]="productionSchedule?.comment"
              [isRestZoneConfigurable]="productionSchedule?.isRestZoneConfigurable()"
              [factorForConversionFromDentsToMillimeters]="factorForConversionFromDentsToMillimeters"
              [needsToShowValidationFeedback]="needsToShowValidationFeedback"
              [defaultInitialRestZones]="defaultInitialRestZones"
              [weaveQualityType]="getWeaveQualityType()"
              [areAllFieldsDisabled]="areAllFieldsDisabled"
              (formValuesChanged)="additionalOptionsChanged()"
              (restZoneLoaded)="restZoneLoaded.emit()"
              (freeZoneLoaded)="freeZoneLoaded.emit()"
              (generateName)="refreshNameGeneration.next()"
            ></app-production-schedule-initial-preparations-additional-options>
          </article>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div *ngIf="canShowAdditionalOptions" class="path-labels-and-jute-wrapper full-width">
    <div class="flex-column full-height">
      <div class="flex-column full-height">
        <mat-card class="skeleton-wrapper full-max-height">
          <mat-card-header class="flex-start-center">
            <mat-card-title class="antialiased flex-row flex-start-center">
              <h3 class="font-weight-bold">
                <ng-container *ngIf="canHaveRestAndFreeZonesAndPathLabels">
                  {{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.PATH_LABELS_AND_JUTE' | bmsTranslate: {count: 2} }}
                </ng-container>
                <ng-container *ngIf="!canHaveRestAndFreeZonesAndPathLabels">
                  {{ 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.JUTE' | bmsTranslate }}
                </ng-container>
              </h3>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="form-scrollable-content">
            <ng-container *ngIf="canHaveRestAndFreeZonesAndPathLabels">
              <article class="path-labels">
                <app-production-schedule-path-labels
                  #pathLabelsComponent
                  [customSettings]="customSettings"
                  [machineQuality]="productionSchedule?.machineQuality"
                  [juteInformation]="productionSchedule?.juteInformation"
                  [(pathLabelInformation)]="productionSchedule.pathLabelInformation"
                  [defaultPathLabelInformation]="defaultPathLabelInformation"
                  [coloredYarnSet]="productionSchedule?.coloredYarnSets[0].coloredYarnSet"
                  [needsToShowValidationFeedback]="needsToShowValidationFeedback"
                  [factorForConversionFromMillimetersToPicks]="factorForConversionFromMillimetersToPicks"
                  [factorForConversionFromPicksToMillimeters]="factorForConversionFromPicksToMillimeters"
                  [areAllFieldsDisabled]="areAllFieldsDisabled"
                  [weaveQualityType]="getWeaveQualityType()"
                  (formValuesChanged)="additionalOptionsChanged()"
                  (pathZoneLoaded)="onPathZoneLoaded()"
                ></app-production-schedule-path-labels>
              </article>
            </ng-container>
            <article class="jute-options-container" *ngIf="canShowJuteOptions()">
              <app-production-schedule-jute-options
                #juteOptionsComponent
                [machineQuality]="productionSchedule?.machineQuality"
                [juteInformation]="productionSchedule?.juteInformation"
                [pathLabelInformation]="productionSchedule?.pathLabelInformation"
                [coloredYarnSet]="productionSchedule?.coloredYarnSets[0].coloredYarnSet"
                [factorForConversionFromPicksToMillimeters]="factorForConversionFromPicksToMillimeters"
                [factorForConversionFromMillimetersToPicks]="factorForConversionFromMillimetersToPicks"
                [machine]="productionSchedule?.machine"
                [needsToShowValidationFeedback]="needsToShowValidationFeedback"
                [weaveQualityType]="getWeaveQualityType()"
                [areAllFieldsDisabled]="areAllFieldsDisabled"
                (juteZoneLoaded)="juteZoneLoaded.emit()"
              >
              </app-production-schedule-jute-options>
            </article>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <ng-container>
    <div *ngIf="canShowAdditionalOptions" class="path-labels-and-jute-wrapper full-width">
      <div class="flex-column full-height">
        <div class="flex-column full-height">
          <mat-card class="skeleton-wrapper full-max-height">
            <mat-card-header class="flex-start-center">
              <mat-card-title class="antialiased flex-row flex-start-center">
                <h3 class="font-weight-bold">
                  {{ 'SETTINGS.MENU_NAME' | bmsTranslate }}
                </h3>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="form-scrollable-content">
              <article>
                <mat-slide-toggle
                  [disabled]="!hasPlanningBoardPermission || areAllFieldsDisabled"
                  class="pb-16"
                  [checked]="hasPlanningBoardPermission && productionSchedule.addToPlanboard"
                  (change)="toggleOnPlanningBoardSettingValue($event.checked)"
                >
                  {{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.ADD_ON_PLANNING_BOARD' | bmsTranslate }}
                </mat-slide-toggle>
                <app-production-schedule-quality-linked-settings
                  *appHasPermission="ADD_JUTE_PERMISSION"
                  #qualityLinkedSettingsComponent
                  [isAddingProductionOrder]="isAddingProductionOrder()"
                  [juteGeneralSettings]="productionSchedule?.juteGeneralSettings"
                  [areAllFieldsDisabled]="areAllFieldsDisabled"
                  [machineQuality]="productionSchedule?.machineQuality"
                >
                </app-production-schedule-quality-linked-settings>
              </article>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </ng-container>
</section>
<app-creel-mapping
  *ngIf="isViewingCreelMap"
  class="flex-1 full-height"
  [coloredYarnSetsWithStartDent]="productionSchedule.coloredYarnSets"
  [creelMap]="getCreelMap()"
  [readOnly]="false"
  (save)="saveCreelMap($event)"
  (cancel)="closeCreelMap()"
></app-creel-mapping>
